<template>
  <div class="tags-input" data-name="tags-input">
    <span
      class="tag"
      v-for="(item, key) in list" :key="key"
      @click="removeItem(key)"
    >
      {{item}}
      <span class="close"></span>
    </span>
    <input
      type="text"
      class="main-input w-330"
      :placeholder="placeholder"
      v-model="text"
      v-on:keyup.enter="addItem"
      v-on:keyup.delete="removeLastItem"
    >
  </div>
</template>
<script>
export default {
  name: "InputTextTags",
  props: {
    list: {
      type: Array,
      default: () => { return [] }
    },
    placeholder: String
  },
  data() {
    return {
      text: ""
    }
  },
  methods: {
    addItem() {
      if(this.list.length >= 0 && this.text.length > 0) {
        this.list.push(this.text);
        this.text = "";
      }
    },
    removeLastItem() {
      if(this.list.length > 0 && this.text.length === 0) {
        this.list.splice(-1,1);
      }
    },
    removeItem(index) {
      this.list.splice(index, 1);
    },
  }
};
</script>
<style scoped>

</style>